export default [
    {
        path: 'relatorio-viagem-veiculo',
        component: () => import(
            /* webpackChunkName: 'transporte-paciente-relatorio-viagem-veiculo' */
            '@/views/transporte-paciente/relatorio-viagem-veiculo/Index'
        ),
        redirect: 'relatorio-viagem-veiculo/index',
        children: [
            {
                name: 'transporte-paciente-relatorio-viagem-veiculo-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'transporte-paciente-relatorio-viagem-veiculo' */
                    '@/views/transporte-paciente/relatorio-viagem-veiculo/List.vue'
                ),
            },
        ],
    },
]
